export const SUBMIT_USER_ACTIVITY_ACTION_REQUESTED =
  "SUBMIT_USER_ACTIVITY_ACTION_REQUESTED";
export const SUBMIT_USER_ACTIVITY_ACTION_DISPATCHER =
  "SUBMIT_USER_ACTIVITY_ACTION_DISPATCHER";
export const SUBMIT_USER_ACTIVITY_ERROR_DISPATCHER =
  "SUBMIT_USER_ACTIVITY_ERROR_DISPATCHER";

export const GET_USER_ACTIVITY_ACTION_REQUESTED =
  "GET_USER_ACTIVITY_ACTION_REQUESTED";

//Action Creator
export const submitUserActivityAction = (data) => ({
  type: SUBMIT_USER_ACTIVITY_ACTION_REQUESTED,
  postData: data,
});


export const getUserActivityAction = (data) => ({
  type: GET_USER_ACTIVITY_ACTION_REQUESTED,
  postData: data,
});

//Action Dispatcher
export const submitUserActivityActionDispatcher = (data) => ({
  type: SUBMIT_USER_ACTIVITY_ACTION_DISPATCHER,
  payload: data,
});

export const submitUserActivityErrorDispatcher = (data) => ({
  type: SUBMIT_USER_ACTIVITY_ERROR_DISPATCHER,
  payload: data,
});



